import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { FlexCenterWrapper, ActionHeaderWrapper, CursorPointerWrapper, Mr2, Mr8, Ml8, Ml1, Ml27p, UnderlineDecoration } from 'wrappers';
import { ClickableIcon, Text, ClickableSecondaryTextSm } from 'atoms';
import { CheckboxSvg } from 'components/icons';
import { OutlinedButton } from 'molecules';

export const definition = {
  name: 'ActionTableHeader',
  controller: Controller,
  initialProps: ({ selectedIds, ids, buttons }) => ({ selectedIds, ids, buttons }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'Checkbox',
      elements: [
        {
          component: wrap(wrap(ClickableIcon, Mr2), Ml27p),
          name: 'Checkbox',
          displayValue: ({ selectedIds, ids }) => CheckboxSvg({ indeterminate: selectedIds?.some(id => ids?.includes(id)) }),
          bindings: ({ }) => ({})
        },
        {
          component: wrap(Text, Ml1),
          name: 'Count',
          displayValue: ({ selectedIds }) => `${selectedIds.length} Selected`,
        },
        {
          component: wrap(wrap(wrap(ClickableSecondaryTextSm, UnderlineDecoration), CursorPointerWrapper), Ml8),
          name: 'Button',
          displayValue: ({ }) => `Unselect All`,
          bindings: () => ({})
        },
      ]
    },
    {
      wrapper: FlexCenterWrapper,
      name: 'Buttons',
      elements: [
        {
          component: wrap(OutlinedButton, Mr8),
          name: 'Button',
          isListOf: 'buttons',
          bindings: ({ button }) => ({ ...button }),
        },
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), ActionHeaderWrapper);